var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8753 2.55867C11.7521 2.38604 11.5894 2.2453 11.4009 2.14814C11.2124 2.05098 11.0034 2.00019 10.7913 2H5.20861C4.77928 2 4.37395 2.20867 4.09728 2.59933L1.43061 6.98667C1.3561 7.10907 1.32305 7.25225 1.33638 7.39493C1.34972 7.53761 1.40871 7.67218 1.50461 7.77867L7.50461 14.4453C7.56679 14.5152 7.64306 14.5712 7.7284 14.6095C7.81375 14.6479 7.90624 14.6677 7.9998 14.6678C8.09336 14.6679 8.18587 14.6481 8.27127 14.6099C8.35666 14.5717 8.433 14.5158 8.49528 14.446L14.4953 7.77933C14.5914 7.67295 14.6505 7.53836 14.6638 7.39563C14.6772 7.25289 14.644 7.10967 14.5693 6.98733L11.8753 2.55867ZM7.99995 13.0033L3.49661 8H12.5026L7.99995 13.0033ZM3.18461 6.66667L5.20861 3.33333L10.7633 3.292L12.8146 6.66667H3.18461Z",
    fill: "#14161A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.a1b470dbaf52984828475b04ca07762c.svg";
export { ForwardRef as ReactComponent };